import formatDate from '@/shared/utils/formatDate'
import getFullName from '@/shared/utils/getFullName'
import { createColumnHelper } from '@tanstack/react-table'

const columnHelper = createColumnHelper<Record<string, any>>()

export const homePageColumns = [
    columnHelper.accessor((row) => getFullName(row.child), {
        cell: (info) => {
            return info.getValue()
        },
        id: 'fullName',
        header: 'Child’s Name'
    }),
    columnHelper.accessor('checkedInParentBy.phoneNumber', {
        cell: (info) => {
            return info.getValue()
        },
        id: 'parentPhoneNumber',
        header: 'Check-in Parent’s Number'
    }),
    columnHelper.accessor('checkedInDate', {
        cell: (info) => formatDate(info.getValue()),
        header: 'Check-In Time'
    }),
    columnHelper.accessor('checkinCode', {
        cell: (info) => info.getValue(),
        header: 'Checkout Code',
        enableSorting: false
    }),
    columnHelper.accessor('checkedOutDate', {
        cell: (info) => formatDate(info.getValue()),
        header: 'Check Out Time'
    }),
    columnHelper.accessor(
        (row) => {
            return (
                getFullName(row.checkedInParentBy) ||
                getFullName(row.checkedInAlternativeContactBy)
            )
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked-In by'
        }
    ),
    columnHelper.accessor(
        (row) => {
            return (
                getFullName(row.checkedOutParentBy) ||
                getFullName(row.checkedOutAlternativeContactBy)
            )
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked out by'
        }
    )
]

export const teacherReportPageColumns = [
    columnHelper.accessor((row) => getFullName(row.child), {
        cell: (info) => {
            return info.getValue()
        },
        id: 'fullName',
        header: 'Child’s Name'
    }),
    columnHelper.accessor('checkedInParentBy.phoneNumber', {
        cell: (info) => {
            return info.getValue()
        },
        id: 'parentPhoneNumber',
        header: 'Check-in Parent’s Number'
    }),
    columnHelper.accessor('checkedInDate', {
        cell: (info) => formatDate(info.getValue()),
        header: 'Check In Time'
    }),
    columnHelper.accessor('checkinCode', {
        cell: (info) => info.getValue(),
        header: 'Checkout Code',
        enableSorting: false
    }),
    columnHelper.accessor('checkedOutDate', {
        cell: (info) => formatDate(info.getValue()),
        header: 'Check Out Time'
    }),
    columnHelper.accessor(
        (row) => {
            return (
                getFullName(row.checkedInParentBy) ||
                getFullName(row.checkedInAlternativeContactBy)
            )
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked In by'
        }
    ),
    columnHelper.accessor(
        (row) => {
            return (
                getFullName(row.checkedOutParentBy) ||
                getFullName(row.checkedOutAlternativeContactBy)
            )
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked out by'
        }
    ),
    columnHelper.accessor(
        (row) => {
            return getFullName(row.checkedInUserBy)
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked In Teacher'
        }
    ),
    columnHelper.accessor(
        (row) => {
            return getFullName(row.checkedOutUserBy)
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked Out Teacher'
        }
    )
]

export const staleCheckoutColumns = [
    columnHelper.accessor((row) => getFullName(row.child), {
        cell: (info) => info.getValue(),
        id: 'fullName',
        header: "Child's Name"
    }),
    columnHelper.accessor('checkedInParentBy.phoneNumber', {
        cell: (info) => info.getValue() || 'N/A',
        id: 'parentPhoneNumber',
        header: "Check-in Parent's Number"
    }),
    columnHelper.accessor('checkedInDate', {
        cell: (info) => formatDate(info.getValue()),
        header: 'Check-In Time'
    }),
    columnHelper.accessor('checkinCode', {
        cell: (info) => info.getValue(),
        header: 'Checkout Code',
        enableSorting: false
    }),
    columnHelper.accessor(
        (row) => {
            return (
                getFullName(row.checkedInParentBy) ||
                getFullName(row.checkedInAlternativeContactBy) ||
                'N/A'
            )
        },
        {
            cell: (info) => info.getValue(),
            header: 'Checked-In by'
        }
    )
]
